import Vue from 'vue';
import App from './App.vue';
import router from './router';
import axios from 'axios';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import moment from 'moment';
import ElementUI from 'element-ui';
import './mixin/install';
import 'element-ui/lib/theme-chalk/index.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'swiper/swiper-bundle.css';
import VueAMap from 'vue-amap';
Vue.use(ElementUI);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(VueAwesomeSwiper);
Vue.prototype.$moment = moment;
Vue.prototype.$axios = axios;
Vue.config.productionTip = false;
Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
	key: '5e6e0524ab3f9ab32344dce2c3c17ce8',
	plugin: [
		'AMap.Autocomplete',
		'AMap.PlaceSearch',
		'AMap.Scale',
		'AMap.OverView',
		'AMap.ToolBar',
		'AMap.MapType',
		'AMap.PolyEditor',
		'AMap.CircleEditor',
	],
	v: '1.4.4',
});
var vue = new Vue({
	router,
	render: (h) => h(App),
}).$mount('#app');
export default vue;
